import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { MechanicTimeCodeBusinessService } from 'projects/Administration/src/app/business-services/mechanic-time-code.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { JobTimeStampSummary, WoTimeStampSummary } from 'projects/Administration/src/app/business-entities/time-stamp-summary';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Features } from 'projects/Widget/src/app/business-entities/step.class';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mechanic-clockin',
  templateUrl: './mechanic-clockin.component.html',
  styleUrls: ['./mechanic-clockin.component.css']
})
export class MechanicClockinComponent implements OnInit, OnDestroy {
  closeResult: string;
  expanded:boolean = false;
  jobStatus:number;
  jobShowStatus:string;
  updatedJobValue:boolean = true;
  workOrderTimeStampSummary: WoTimeStampSummary[];
  jobTimeStampSummary: JobTimeStampSummary[];
  activePanelIds: string[] = ['static-1', 'static-2'];
  tooltipPlacement = 'right';
  appointmentDemandId:number;
  jobNo:number;
  jobDescription:string;
  totaltime:string;
  totalspenttime:string;
  featureList: Features[] = [];
  isWorkorderTimer: boolean = false;
  isJobDetailsTimerFeature: boolean = false;
  subscription: Subscription;
  constructor(
    private modalService: NgbModal,
    private service: MechanicTimeCodeBusinessService,
    private readonly editAppointmentService: EditAppointmentService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private currentLanguageService: CurrentLanguage,
    private secureStorage: SecureStorage,
  ) { 
    this.getFeatures();
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.service.getTimeStampSummary(this.editAppointmentService.appointmentDetails.workOrderNo).then((res)=>
    {
      if(res.responseObject!=null){
        this.workOrderTimeStampSummary = res.responseObject?.woTimeStampSummary
        this.jobTimeStampSummary = res.responseObject?.jobTimeStampSummary
        this.totaltime = res.responseObject?.timeDetails.plannedTime;
        this.totalspenttime = res.responseObject?.timeDetails.totalTimeSpent;
        if(this.workOrderTimeStampSummary?.length > 0){
          this.workOrderTimeStampSummary.forEach((data)=>{
            data.startTime = Utility.ConvertUTCDateToLocalDate(data.startTime);
            data.endTime = Utility.ConvertUTCDateToLocalDate(data.endTime);
            data.updatedDate = Utility.ConvertUTCDateToLocalDate(data.updatedDate);
          })
        }
        if(this.jobTimeStampSummary?.length > 0){
          this.jobTimeStampSummary.forEach((data)=>{
            if(data.jobTimeStamps?.length>0){
              data.jobTimeStamps?.forEach((job)=>{
                job.startTime = Utility.ConvertUTCDateToLocalDate(job.startTime);
                job.endTime = Utility.ConvertUTCDateToLocalDate(job.endTime);
                job.updatedDate = Utility.ConvertUTCDateToLocalDate(job.updatedDate);
              })
            }
            data.expanded = true;
          })
        }
        this.appointmentDemandId = res.responseObject?.jobTimeStampSummary[0].appointmentDemandId
      }
    })
    .finally(()=> this.spinner.hide())
  }
  async getFeatures() {
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList && this.featureList.length > 0) {
        this.isWorkorderTimer = this.featureList.find(x => x.featureCode === Enums.FeatureCode.WorkorderTimer)?.isActive;
        this.isJobDetailsTimerFeature = this.featureList.find(x => x.featureCode === Enums.FeatureCode.JobDetailsTimer)?.isActive;
      }
      else {
        this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
          this.featureList = res;
          if (this.featureList && this.featureList.length > 0) {
            this.isWorkorderTimer = this.featureList.find(x => x.featureCode === Enums.FeatureCode.WorkorderTimer)?.isActive;
            this.isJobDetailsTimerFeature = this.featureList.find(x => x.featureCode === Enums.FeatureCode.JobDetailsTimer)?.isActive;
          }
        })
      }
    }
  }
  updateJobStatus(job)
  {
    this.appointmentDemandId = job?.appointmentDemandId;
    this.jobNo = job?.jobNo;
    this.jobDescription = job?.description;
    if(job.demandStatus == Enums.jobStatus.Pending)
    {
      this.jobShowStatus = Enums.jobStatus.Pending;
      this.jobStatus = 1;
    }
    else if(job.demandStatus == Enums.jobStatus.InProgress)
    {
      this.jobShowStatus = Enums.jobStatus.InProgress;
      this.jobStatus = 2;
    }
    else
    {
      this.jobShowStatus = Enums.jobStatus.Completed;
      this.jobStatus = 3;
    }
  }

  openUpdateJob(content,job)
  {
    this.updateJobStatus(job);
    this.modalService.open(content, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  ChangeJobStatusValue(event:any)
  {
    this.jobStatus = event.target.value;
    this.updatedJobValue = false;
  }

  async serviceFunction()
  {
    this.spinner.show();
    let updateModel = {
      appointmentDemandId:Number(this.appointmentDemandId),
      jobStatusId:Number(this.jobStatus),
      appointmentGUID:this.editAppointmentService.appointmentDetails.appointmentGuid,
      job:this.jobDescription,
      jobNo:this.jobNo
    }
    this.service.updateJobStatus(updateModel).then(res=>{
      if(res.status == 1)
      {
        this.jobTimeStampSummary[0].statusId = this.jobStatus;
        document.getElementById("modelButton").click();
        let SuccessMessage = this.translate.instant("lblJobStatusUpdated");
        this.toastr.success(SuccessMessage);
        this.ngOnInit();
        this.updatedJobValue = true;
      }
      else
      {
        document.getElementById("modelButton").click();
      }
    })
    this.spinner.hide();
  }

  open(content) {
    this.modalService.open(content, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  openCorrection(content){
    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  onClockOut() {
        let modelHeadermsg = "ClockOut";
        let modelBodymsg = "Are you sure to clock out";
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => {
          // This is intentional
          }, (reason) => {
          let popupCloseResult = this.getDismissReason(reason);
          if (popupCloseResult) {
        }
      }).finally(()=>{
        
      });
    }

}
